<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-15 13:47:01
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:26:21
--> 
<template>
  <div class="bigbox">
    <div>
      <!-- <span class="span2"
            :style="{color: $vuetify.theme.defaults.light.primary}"
            v-if="readonly"
            @click="addvariate">{{$t('label_Join_the_variables')}}
        <mrc_ess_svgIcon iconClass='open_in_new'></mrc_ess_svgIcon>
      </span> -->
      <v-btn
        text
        class="pa-0"
        v-if="readonly"
        @click="addvariate"
        color="primary"
      >
        {{ $t("label_Join_the_variables") }}
        <mrc_ess_svgIcon
          iconClass="open_in_new"
          style="font-size: 20px"
        ></mrc_ess_svgIcon>
      </v-btn>
    </div>
    <mrc_ess_myDialog
      v-model="dialog"
      hiddenTitle
      cardTextPadding="pa-4"
      :title="$t('label_Join_the_variables')"
      width="600"
      :disabled="false"
      @cancel="close"
    >
      <v-card-text class="pa-0">
        <v-tabs
          v-model="tab"
          grow
          background-color="#ffffff"
          color="primary"
          dark
        >
          <v-tab
            v-for="(item, index) in items"
            class="text-capitalize"
            :key="index"
          >
            {{ item.tab }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item style="overflow-y: scroll; max-height: 500px">
            <div v-for="(item, index) in variatelist" :key="index + item">
              <div
                class="ptbox d-flex align-center pl-2"
                @click="changebgd(item, index)"
                :class="item.divbgd ? 'divbgd' : ''"
              >
                <!-- <div class="ml-2 mr-1 ">
                  <v-checkbox v-model="item.divbgd"
                              @click="changebgd(item,index)">
                  </v-checkbox>
                </div> -->
                <div>
                  <div style="color: rgba(0, 0, 0, 0.78)">
                    {{ item[itemText] }}
                  </div>
                  <div style="color: rgba(0, 0, 0, 0.6)">
                    {{ item.field_name }}
                  </div>
                </div>
              </div>
            </div>
          </v-tab-item>

          <v-tab-item style="overflow-y: scroll; max-height: 500px">
            <div v-for="(item, index) in syslist" :key="index + item">
              <div
                class="ptbox d-flex align-center pl-2"
                @click="changebgd2(item, index)"
                :class="item.divbgd ? 'divbgd' : ''"
              >
                <!-- <div class="ml-2 mr-1 ">
                  <v-checkbox v-model="item.divbgd"
                              @click="changebgd2(item,index)">
                  </v-checkbox>
                </div> -->
                <div class="d-flex align-center flex-column">
                  <div style="color: rgba(0, 0, 0, 0.78)">
                    {{ item[itemText] }}
                  </div>
                  <div style="color: rgba(0, 0, 0, 0.6)">
                    {{ item.field_name }}
                  </div>
                </div>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </mrc_ess_myDialog>
  </div>
</template>

<script>
import {
  getemailtemplatelist,
  getdetailemailtemplate,
  updateemailtemplate,
  templatesysList,
} from "@/service/api/emailtemplate";
import { getBusinessList } from "@/service/api/prompt.js";
export default {
  components: {},
  props: {
    readonly: {
      type: Boolean,
      default: true,
    },
    function_uuid: {
      type: String,
    },
    sysStatus: {
      type: Boolean,
      default: false,
    },
    itemValue: {
      type: String,
      default: "value_field",
    },
    itemText: {
      type: String,
      default: "view_fields",
    },
    type: {
      type: Number,
      default: 1,
    },
    // updateFunction_uuid: {
    //   type: String
    // },
  },
  data() {
    return {
      itemss: [],
      offset: true,
      tab: null,
      dialog: false,
      variatelist: [],
      syslist: [],
    };
  },
  computed: {
    items() {
      if (this.type == 1) {
        return [
          { tab: this.$t("label_functionVar") },
          { tab: this.$t("label_systemVar") },
        ];
      } else {
        return [{ tab: this.$t("label_functionVar") }];
      }
    },
  },
  created() {},
  watch: {
    async function_uuid(v) {
      if (v) {
        const res = await getBusinessList({
          prompt_name: "email_address_field",
          uuid: v,
        });
        if (res.code == 200) {
          this.variatelist = res.data.map((item) => {
            item.property = "{{" + item[this.itemValue] + "}}";
            return { ...item, divbgd: false };
          });
        }
      }
    },
  },
  mounted() {},
  methods: {
    async getvariatelist() {
      //获取属性字段列表
      //发送请求)
      if (!this.variatelist.length > 0) {
        const res = await getBusinessList({
          prompt_name: "email_address_field",
          uuid: this.function_uuid,
        });
        if (res.code == 200) {
          this.variatelist = res.data.map((item) => {
            item.property = "{{" + item[this.itemValue] + "}}";
            return { ...item, divbgd: false };
          });
        }
      }
      // this.variatelist = this.variatelist.map(item => {
      //   return { ...item, divbgd: false }
      // })
    },
    async getsyslist() {
      //获取系统变量
      //发送请求)
      if (this.sysStatus) {
        const res = await templatesysList();
        // console.log(res);
        if (res.code != 200) return (this.syslist = []);
        let arr = [];
        for (let key in res.data) {
          let obj = {};
          obj.property = "{{" + res.data[key] + ":SYS}}";
          obj[this.itemText] = res.data[key];
          arr.push(obj);
          obj = {};
        }
        // console.log(arr);
        this.syslist = arr;
        console.log(arr);
        // this.syslist = [ //系统变量
        //   {
        //     property: '{{112saaas}}',
        //     name: 'xasxaxaaxa'
        //   },
        //   {
        //     property: '{{112xasaokhhh}}',
        //     name: 'xasxaxaaxa'
        //   },
        //   {
        //     property: '{{112qqqws}}',
        //     name: 'xasxaxaxaxaaxa'
        //   },
        // ]
        this.syslist = this.syslist.map((item) => {
          return { ...item, divbgd: false };
        });
      } else {
        this.syslist = [];
      }
    },
    async addvariate() {
      this.dialog = true;
      await this.getvariatelist();
      await this.getsyslist();
    },
    changebgd(item, index) {
      item.divbgd = !item.divbgd;
      this.$set(this.variatelist, index, item);
      this.close();
    },
    changebgd2(item, index) {
      item.divbgd = !item.divbgd;
      this.$set(this.syslist, index, item);
      this.close();
    },
    close() {
      this.dialog = false;
      let newpropertylist = [];
      let variatelist = [];
      let syslist = [];
      this.variatelist.map((item) => {
        if (item.divbgd == true) {
          variatelist.push(item);
          newpropertylist.push(item);
        }
      });
      this.syslist.map((item) => {
        if (item.divbgd == true) {
          syslist.push(item);
          newpropertylist.push(item);
        }
      });
      this.$emit("getpropertylist", variatelist);
      this.$emit("getsyslist", syslist);
      this.$emit("getalllist", newpropertylist);
      this.variatelist = this.variatelist.map((item) => {
        return { ...item, divbgd: false };
      });
      this.syslist = this.syslist.map((item) => {
        return { ...item, divbgd: false };
      });
    },
    save() {
      // this.$v.editedItem.$touch()
      // if (this.$v.editedItem.$error) return
      // this.close()
    },
  },
};
</script>

<style scoped>
.divbgd {
  background-color: #e5eeff;
}
/deep/ .v-tabs {
  padding-bottom: 0px !important;
}
.span2 {
  font-family: var(--body-font-family);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
}
.span2 /deep/.svg-icon {
  font-size: 20px;
}
.ptbox {
  display: flex;
  height: 58px;
  /* flex-direction: column; */
  /* height: 50px; */
  border-bottom: 2px solid #eeeef0;
}
.ptbox:hover {
  background-color: #e5eeff;
}
/* .bigbox /deep/.v-card__text {
  position: absolute;
  z-index: 12;
  top: -49px;
  left: -17px;
} */
</style>
